<crud-list class="col-12" [data]="table" detailUrl="/enaio-learn/admin/user-group/" restUrl="api/lrn/usergroup">
</crud-list>
